import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import virtual_components from '@devices/settings/device_settings/virtual_components';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import app from '@devices/settings/device_settings/app';
import addon_sensors from '@devices/settings/device_settings/addon_sensors';
import timer_gen_2 from './timer_gen_2';
import night_mode_gen_2 from './night_mode_gen_2';
import bluetooth_bt_home_control_gen_2 from './bluetooth_bt_home_control_gen_2';

export const xt1_device_settings = {
	title: 'settings',
	components: [
		{ title: 'device_name', component: 'device_name_sys' },
		{ title: 'firmware_version', component: 'firmware_update' },
		{ title: 'geo_location_and_time_zone', component: 'location_g2' },
		{ title: 'device_reboot', component: 'device_reboot' },
		{ title: 'factory_reset', component: 'factory_reset' },
		{ title: 'device_information', component: 'device_information' },
	],
};

export const xt1_default_settings = [
	schedule_gen_2,
	webhooks_gen_2,
	networks_gen_2_plus,
	bluetooth_gen_2,
	virtual_components,
];

export const xt1_default_and_addon_settings = [
	schedule_gen_2,
	webhooks_gen_2,
	addon_sensors,
	networks_gen_2_plus,
	bluetooth_gen_2,
	virtual_components,
];

const xt1_component_default_settings = [
	schedule_gen_2,
	webhooks_gen_2,
	networks_gen_2_plus,
	virtual_components,
];

const createXT1LightSettings = (components, { remoteControl = false } = {}) => [
	timer_gen_2,
	night_mode_gen_2,
	...xt1_component_default_settings,
	remoteControl ? bluetooth_bt_home_control_gen_2 : bluetooth_gen_2,
	app,
	share,
	{
		title: 'settings',
		components: [...components, ...xt1_device_settings.components],
	},
];

const nameSetting = { title: 'device_name', component: 'device_name_g2' };
const inputOutputSetting = { title: 'input_output', component: 'input_output_g2_rgbw' };
const buttonFadeRateSetting = { title: 'button_fade_rate', component: 'button_fade_rate_g2' };
const minBrightnessSetting = {
	title: 'min_brightness_on_toggle',
	component: 'min_brightness_on_toggle_g2',
};

export const xt1_inputs_reader_settings = [
	...xt1_component_default_settings,
	bluetooth_bt_home_control_gen_2,
	app,
	share,
	{
		title: 'settings',
		components: [
			nameSetting,
			{ title: 'input', component: 'input_output_g2' },
			{
				title: 'enable_input',
				component: 'enable_input_g2',
				min_ver: '1.0.7',
			},
			{ title: 'invert_input', component: 'invert_switch_g2' },
			...xt1_device_settings.components,
		],
	},
];

export const xt1_light_settings = createXT1LightSettings(
	[
		nameSetting,
		inputOutputSetting,
		buttonFadeRateSetting,
		minBrightnessSetting,
		{ title: 'button_presets', component: 'button_presets_g2' },
	],
	{ remoteControl: true },
);

export const xt1_cct_settings = createXT1LightSettings(
	[
		nameSetting,
		inputOutputSetting,
		{ title: 'transition_duration', component: 'transition_g2' },
		minBrightnessSetting,
		buttonFadeRateSetting,
	],
	{ remoteControl: true },
);

const xt1ColorSettings = [
	nameSetting,
	inputOutputSetting,
	buttonFadeRateSetting,
	minBrightnessSetting,
	{ title: 'button_presets', component: 'button_presets_prorgbww' },
];

export const xt1_rgb_settings = createXT1LightSettings(xt1ColorSettings);
export const xt1_rgbw_settings = createXT1LightSettings(xt1ColorSettings);

export const xt1_cover_settings = [
	...xt1_component_default_settings,
	bluetooth_gen_2,
	app,
	share,
	{
		title: 'settings',
		components: [
			nameSetting,
			{ title: 'calibration', component: 'calibration_g2' },
			{ title: 'reverse_directions', component: 'reverse_direction_g2' },
			{ title: 'movement_time_limits', component: 'movement_time_limits_g2' },
			{ title: 'action_on_power_on', component: 'action_on_power_on_g2_cover' },
			{ title: 'idle_power_threshold', component: 'idle_power_threshold_g2' },
			{ title: 'input_type', component: 'input_type_g2_cover' },
			{ title: 'lock_inputs', component: 'lock_inputs_g2' },
			{ title: 'operational_counters', component: 'operational_counters_g2' },
			...xt1_device_settings.components,
		],
	},
];

export default [...xt1_default_settings, app, share, xt1_device_settings];
